// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hero.is-small .hero-body[data-v-615fe030]{padding-bottom:0}", ""]);
// Exports
module.exports = exports;
